module.exports = __webpack_public_path__ + "static/lora-variable-337fa370c6ba675d1c9d3ba0d1444145.ttf";